import { array } from '@ember/helper';
import { on } from '@ember/modifier';

import joinClasses from 'webapp/helpers/join-classes';
import BarLoaderComponent from 'webapp/components/bar-loader';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/metric-library/grid-item-base';
import MetricLibraryGridItemBaseComponent from 'webapp/components/metric-library/grid-item-base';

export default class SourceMetricsGridItem<
	T extends Args,
> extends MetricLibraryGridItemBaseComponent<T> {
	get icon(): IconName | undefined {
		return 'Plus';
	}
	<template>
		<li
			class={{joinClasses
				(array
					this.model.animationClass
					"card card--small-metric-type flex-item filter-sort-item"
				)
			}}
		>

			<div class="card__wrapper">
				<div class="card__header">
					<div class="card__source">
						<img src={{this.sourceAvatar}} alt={{this.sourceTitle}} />
						<div class="card__source-name">
							<div class="overflowable">{{this.sourceTitle}}</div>
						</div>
					</div>
					<div class="card__metric">
						<div class="card__metric-name">
							{{this.metricName}}
						</div>
					</div>
				</div>
				{{#unless @isStatusHidden}}
					{{#if this.isDisabled}}
						<CommonUiIconComponent @name="Lock" @size="sm" @class="card__status" />
					{{/if}}
				{{/unless}}
			</div>

			{{#if this.isOverlayShown}}

				{{#if this.isLoading}}
					<div role="button" class="overlay overlay--shown">
						<BarLoaderComponent @theme="white" />
					</div>
				{{else}}
					<div role="button" class="overlay" {{on "click" this.createNew}}>
						{{#if this.icon}}
							<CommonUiIconComponent
								@name={{this.icon}}
								@size="sm"
							/>{{this.buttonText}}
						{{else}}
							<span>{{this.buttonText}}</span>
						{{/if}}
					</div>
				{{/if}}

			{{/if}}

		</li>
	</template>
}
